import Vue from "vue";
import VueRouter from "vue-router";
import LoginPage from "@/views/LoginPage.vue";
import DashboardPage from "@/views/DashboardPage.vue";
import CarsPage from "@/views/CarsPage.vue";
import CarDetailsPage from "@/views/CarDetailsPage.vue";
import PartSearchPage from "@/views/PartSearchPage.vue";
import PartDetailsPage from "@/views/PartDetailsPage.vue";
import RegistrationPage from "@/views/RegistrationPage.vue";
import NewRegistrationPage from "@/views/NewRegistrationPage.vue";
import SelectPartGroupsPage from "@/views/SelectPartGroupsPage.vue";
import QRCodePage from "@/views/QRCodePage.vue";
import BarcodePage from "@/views/BarcodePage.vue";
import OrdersPage from "@/views/OrdersPage.vue";
import CollectionListPage from "@/views/CollectionListPage.vue";
import CameraPage from "@/views/CameraPage.vue";
import SearchPage from "@/views/SearchPage.vue";
import BackgroundTaskPage from "@/views/BackgroundTaskPage.vue";
import ManualTaskPage from "@/views/ManualTaskPage.vue";
import FeedbackPage from "@/views/FeedbackPage.vue";
import EnterCarDetailsPage from "@/views/EnterCarDetailsPage.vue";
import EnterNewPart_NewOrder from "@/views/EnterNewPart_NewOrder.vue";
import EnterNewPartCarReg from "@/views/EnterNewPartCarRegPage.vue"
import EnterCarVinPage from "@/views/EnterCarVinPage.vue";
import EnterCarRegNumPage from "@/views/EnterCarRegNumPage.vue";
import SelectRegistrationMethodPage from "@/views/SelectRegistrationMethodPage.vue"
import TakeCarDocPhotoPage from "@/views/TakeCarDocPhotoPage.vue"
import TakeCarPhotoPage from "@/views/TakeCarPhotoPage.vue"
import SelectPartsPage from "@/views/SelectPartsPage.vue"
import SelectCar from "@/views/SelectCar.vue"
import AssessPartCondition from "@/views/AssessPartCondition.vue"
import ProcessSuccessPage from "@/views/ProcessSuccessPage.vue"
import SelectPartPage from "@/views/SelectPartPage.vue"
import TakePartPhotosPage from "@/views/TakePartPhotosPage.vue"
import TakePartPhotosCarRegPage from "@/views/TakePartPhotosCarRegPage.vue"

import PrintPartStickerPage from "@/views/PrintPartStickerPage.vue"
import ProcessErrorPage from "@/views/ProcessErrorPage.vue"
import ScanWarehouseLocationPage from "@/views/ScanWarehouseLocationPage.vue"
import ScanPartPage from "@/views/ScanPartPage.vue"

// dummy views for test purpose only
import AssignReviewer from "../views/AssignReviewer.vue";
import ReviewInvoice from "../views/ReviewInvoice.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('isAuthenticated')
      if (isAuthenticated == 'true') {
        next({name: 'dashboard'})
      } else {
        next()
      }
    }
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardPage,
  },
  {
    path: "/car",
    name: "car",
    component: CarsPage,
  },
  {
    path: "/collectionlist",
    name: "collectionlist",
    component: CollectionListPage,
  },
  {
    path: "/car/:id",
    name: "cardetails",
    component: CarDetailsPage,
  },
  {
    path: "/partsearch",
    name: "partsearch",
    component: PartSearchPage,
  },
  {
    path: "/part/:id",
    name: "part",
    component: PartDetailsPage,
  },
  {
    path: "/newregistration",
    name: "newregistration",
    component: NewRegistrationPage,
  },
  {
    path: "/registration",
    name: "registration",
    component: RegistrationPage,
  },
  {
    path: "/selectPartGroups",
    name: "SelectPartGroups",
    component: SelectPartGroupsPage,
  },
  {
    path: "/selectParts",
    name: "SelectParts",
    component: SelectPartsPage,
  },
  {
    path: "/qrcode",
    name: "qrcode",
    component: QRCodePage,
  },
  {
    path: "/barcode",
    name: "barcode",
    component: BarcodePage,
  },
  {
    path: "/orders",
    name: "orders",
    component: OrdersPage,
  },
  {
    path: "/camera",
    name: "camera",
    component: CameraPage,
  },
  {
    path: "/assignReviewer",
    name: "assignReviewer",
    component: AssignReviewer,
  },
  {
    path: "/reviewInvoice",
    name: "reviewInvoice",
    component: ReviewInvoice,
  },
  {
    path: "/search",
    name: "search",
    component: SearchPage,
  },
  {
    path: "/backgroundtask",
    name: "backgroundtask",
    component: BackgroundTaskPage,
  },
  {
    path: "/manualtask",
    name: "manualtask",
    component: ManualTaskPage,
  },
  {
    path: "/feedback",
    name: "feedback",
    component: FeedbackPage,
  },
  {
    path: "/enterCarDetails",
    name: "EnterCarDetails",
    component: EnterCarDetailsPage,
  },
  {
    path: "/enterNewPart_NewOrder",
    name: "EnterNewPart_NewOrder",
    component: EnterNewPart_NewOrder,
  },
  {
    path: "/enterVin",
    name: "EnterVIN",
    component: EnterCarVinPage,
  },
  {
    path: "/selectCarRegistrationMethod",
    name: "SelectCarRegistrationMethod",
    component: SelectRegistrationMethodPage,
  },
  {
    path: "/enterCarRegistrationNumber",
    name: "EnterCarRegistrationNumber",
    component: EnterCarRegNumPage,
  },
  {
    path: "/photographCarRegistrationDocuments",
    name: "PhotographCarRegistrationDocuments",
    component: TakeCarDocPhotoPage
  },
  {
    path: "/takeCarPhotos",
    name: "TakeCarPhotos",
    component: TakeCarPhotoPage
  },
  {
    path: "/selectCar",
    name: "SelectCar", 
    component: SelectCar
  },
  {
    path: "/assessPartCondition",
    name: "AssessPartCondition", 
    component: AssessPartCondition
  },
  {
    path: "/processSuccess",
    name: "ProcessSuccess", 
    component: ProcessSuccessPage
  },
  {
    path: "/selectPart",
    name: "SelectPart", 
    component: SelectPartPage
  },
  {
    path: "/printPartStickerPage",
    name: "PrintPartSticker", 
    component: PrintPartStickerPage
  },
  {
    path: "/takePartPhotos",
    name: "TakePartPhotos", 
    component: TakePartPhotosPage
  },
  {
    path: "/takePartPhotosCarReg",
    name: "TakePartPhotosCarReg", 
    component: TakePartPhotosCarRegPage
  },
  {
    path: "/processError",
    name: "ProcessError", 
    component: ProcessErrorPage
  },
  {
    path: "/scanWarehouseLocation",
    name: "ScanWarehouseLocation", 
    component: ScanWarehouseLocationPage
  },
  {
    path: "/scanPart",
    name: "ScanPart", 
    component: ScanPartPage,
  },
  {
    path:"/enterNewPartCarReg",
    name: "EnterNewPartCarReg",
    component: EnterNewPartCarReg
  }
  
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated')

  if (to.name !== 'login' && !isAuthenticated) {
    console.log('Not Authenticated. Redirects to login')
    next({name: 'login'})
  } else {
    localStorage.setItem('page', to.name)
    next();
  }
})


export default router;
